import * as types from 'modules/checklists/actionTypes';
import type {
  FetchChecklistsSelectSuccessAction,
  FetchDefaultChecklistSuccessAction,
  FetchSelectedChecklistsSuccess,
} from 'modules/checklists/types';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDefaultChecklistIdReducer = Record<string, string>;

const initialState: ChecklistUiDefaultChecklistIdReducer = {};

const afterFetchDefaultChecklist = (
  state: ChecklistUiDefaultChecklistIdReducer,
  { payload: checklist }: FetchDefaultChecklistSuccessAction
): ChecklistUiDefaultChecklistIdReducer => ({ ...state, [checklist.type]: checklist.id });

const afterFetchAvailableChecklists = (
  state: ChecklistUiDefaultChecklistIdReducer,
  { payload }: FetchChecklistsSelectSuccessAction | FetchSelectedChecklistsSuccess
): ChecklistUiDefaultChecklistIdReducer =>
  payload.content
    .filter(({ dealerId, groupId, interventionId }) => !interventionId && !dealerId && !groupId)
    .reduce((acc, checklist) => ({ ...acc, [checklist.type]: checklist.id }), state);

export default createReducer(
  initialState,
  {
    [types.FETCH_DEFAULT_CHECKLIST_SUCCESS]: afterFetchDefaultChecklist,
    [types.FETCH_CHECKLISTS_SELECT_SUCCESS]: afterFetchAvailableChecklists,
  },
  [
    {
      matcher: ({ type, meta }) => type === types.FETCH_SELECTED_CHECKLISTS_SUCCESS && meta?.source === 'defaultChecklists',
      reducer: afterFetchAvailableChecklists,
    },
  ]
);
